import { defineComponent } from "vue";

/**
 * 渲染 `AccountSafe` SVG 图标。
 *
 * @remarks
 * Vue 透传属性（如 `class`、`style`、`role`、`aria-label`、`width`、`height` 和 `fill`）会应用到根 `<svg>` 元素。
 */
export const AccountSafe = defineComponent({
	name: "AccountSafe",
	render() {
		return (
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
				<path d="M510.91911111 90.48746667a736.14222222 736.14222222 0 0 0 348.62648889 114.41493333v379.6992c0 143.01866667-233.80195555 294.61617778-348.62648889 357.54666667-112.08248889-65.08088889-343.81368889-214.528-343.81368889-357.54666667V207.07555555c122.19733333-8.20337778 240.4352-48.28728889 343.81368889-116.55395555m0-87.9616c-105.96124445 80.21333333-232.10666667 126.45262222-363.06488889 133.00622222a433.33404445 433.33404445 0 0 1-51.57546667 0v449.03537778c2.05937778 238.84231111 414.64035555 435.48444445 414.64035556 435.48444445S928.30151111 824.88888889 928.30151111 586.0352V132.67626667h-26.16888889c-140.24248889 0.15928889-277.06026667-45.35182222-391.21351111-130.1504z" />
				<path d="M512 528.30435555c-86.26631111 0-156.44444445-70.17813333-156.44444445-156.43306666s70.17813333-156.44444445 156.44444445-156.44444444 156.44444445 70.17813333 156.44444445 156.44444444S598.30044445 528.30435555 512 528.30435555z m0-251.44888888a95.00444445 95.00444445 0 1 0 95.00444445 95.00444444 95.10684445 95.10684445 0 0 0-95.00444445-94.99306666z" />
				<path d="M751.42257778 735.51644445h-57.73084445c0-87.95022222-81.48764445-159.50506667-181.64622222-159.50506667s-181.64622222 71.55484445-181.64622222 159.50506667h-57.74222222c0-58.64106667 25.31555555-113.58435555 71.28177778-154.73777778 45.056-40.31146667 104.7552-62.57777778 168.10666666-62.57777778s123.03928889 22.20942222 168.10666667 62.57777778c45.96622222 41.15342222 71.2704 96.09671111 71.2704 154.73777778z" />
			</svg>
		);
	},
});

export default AccountSafe;
